import { useState } from 'react';
import PasswordForm from './PasswordForm';
import ValidatePassword from './ValidatePassword';

const ChangePassword = () => {
    const [isValidate, setIsValidate] = useState(false);
    const [showForm, setShowForm] = useState(true);
    return (
        <div className=''>
            <h2>Cambiar contraseña</h2>

            <ValidatePassword setIsValidate={setIsValidate} isValidate={isValidate} />
            {
                isValidate && showForm && (
                    <div style={{ marginTop: 30 }}>
                        <h4>Escoge una nueva contraseña</h4>
                        <PasswordForm setShowForm={setShowForm} />
                    </div>
                )
            }
        </div>
    );
};

export default ChangePassword;